<script setup lang="ts">
import BrowseHeader from '@/components/browse/header/BrowseHeader.vue';

definePageMeta({
  layout: 'account',
  auth: false,
});

useHead({
  title: 'Refunds Policy',
});

const { data } = await useFetchData('/pages/refunds_policy', { method: 'get' });
</script>

<template>
  <v-container fluid class="account-container">
    <BrowseHeader class="account-header" />

    <div class="account-content">
      <div v-html="data" class="html-data"></div>
    </div>
  </v-container>
</template>
